import { render, staticRenderFns } from "./HLHighscoreList.vue?vue&type=template&id=bbd46068&scoped=true&"
import script from "./HLHighscoreList.vue?vue&type=script&lang=js&"
export * from "./HLHighscoreList.vue?vue&type=script&lang=js&"
import style0 from "./HLHighscoreList.vue?vue&type=style&index=0&id=bbd46068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd46068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSimpleTable})
